import { api } from "./api";
import {
  PhotoReportDetail,
  PhotoReportListParams,
  PhotoReportListResponse,
} from "../../models/photoReports";

export const photoReportsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPhotoReports: build.query<PhotoReportListResponse, PhotoReportListParams>({
      query: (params) => ({
        url: "/bo/photo-reports",
        params,
      }),
      transformResponse: (response: any) => {
        if (response?.success && response.data) {
          return response.data as PhotoReportListResponse;
        }
        return response as PhotoReportListResponse;
      },
      providesTags: ["reports"],
    }),

    getPhotoReportDetail: build.query<PhotoReportDetail, number>({
      query: (id) => ({
        url: `/bo/photo-reports/${id}`,
      }),
      transformResponse: (response: any) => {
        if (response?.success && response.data) {
          return response.data as PhotoReportDetail;
        }
        return response as PhotoReportDetail;
      },
      providesTags: (_r, _e, id) => [{ type: "reports", id }],
    }),

    deletePhotoReport: build.mutation<void, number>({
      query: (id) => ({
        url: `/bo/photo-reports/${id}/delete`,
        method: "POST",
      }),
      invalidatesTags: ["reports"],
    }),

    restorePhotoReport: build.mutation<void, number>({
      query: (id) => ({
        url: `/bo/photo-reports/${id}/restore`,
        method: "POST",
      }),
      invalidatesTags: ["reports"],
    }),
  }),
});

export const {
  useGetPhotoReportsQuery,
  useGetPhotoReportDetailQuery,
  useLazyGetPhotoReportDetailQuery,
  useDeletePhotoReportMutation,
  useRestorePhotoReportMutation,
} = photoReportsApi;
